module.exports = __webpack_public_path__ + "static/media/productos_botanas_cacahuate_espanol.7aae5491.jpg";